export default __webpack_public_path__ + "pypi/jedi-0.19.1-py2.py3-none-any.whl";